import { Component } from "react";
import styles from "./ErrorBoundary.module.css";

const SUPPORT_EMAIL = "connect@ignite-elysium.com";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: "", errorInfo: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo,
    });
  }

  handleRefresh = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      const errorText = this.state.error
        ? this.state.error.toString()
        : "Unknown error";
      const stack =
        this.state.errorInfo && this.state.errorInfo.componentStack
          ? this.state.errorInfo.componentStack
          : "";

      const pageUrl = typeof window !== "undefined" ? window.location.href : "";
      const userAgent =
        typeof navigator !== "undefined" ? navigator.userAgent : "";

      const mailBody = [
        "Hi there,",
        "",
        "I ran into a problem on the Ignite Elysium Music site.",
        "",
        "What I saw:",
        errorText,
        stack ? `Component stack:${stack}` : "",
        "",
        `Page: ${pageUrl}`,
        `Browser: ${userAgent}`,
        "",
        "Thanks!",
      ]
        .filter((line) => line !== undefined)
        .join("\n");

      const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
        "Ignite Elysium Music — component error",
      )}&body=${encodeURIComponent(mailBody)}`;

      return (
        <div className={styles.panel} role="alert" aria-live="assertive">
          <div className={styles.rail} aria-hidden="true" />

          <header className={styles.header}>
            <p className={styles.eyebrow}>Something went wrong</p>
            <h2 className={styles.title}>This section could not load</h2>
            <p className={styles.lead}>
              A piece of the page failed unexpectedly. Refreshing usually fixes
              it — if not, a quick note helps us track it down.
            </p>
          </header>

          <section className={styles.detail} aria-label="Error details">
            <p className={styles.detailLabel}>Details</p>
            <p className={styles.detailBody}>{errorText}</p>
          </section>

          <section className={styles.tips} aria-label="Things to try">
            <p className={styles.tipsHeading}>Things to try</p>
            <ul className={styles.tipsList}>
              <li>Refresh the page</li>
              <li>Confirm you are online and nothing is blocking the site</li>
              <li>Try again in a few minutes if it still fails</li>
            </ul>
          </section>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={this.handleRefresh}
            >
              Refresh page
            </button>
            <a className={styles.secondaryBtn} href={mailtoHref}>
              Email support
            </a>
          </div>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}
